import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import MasterGamesList from "../data/MasterGamesList"

export default function PragmaticPlayDaily() {
  const navigate = useNavigate()
  const data = promotionsData.find((promo) => promo.title === "Sweet Bonanza")
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Sweet Bonanza </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> /{" "}
              <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> SWEET BONANZA WHEEL DROPS </h1>

                <div className="promotion-tnc-period">
                  <strong> Promo Period: </strong>
                  <span>
                    <br />
                    May 5, 2026 - May 19 , 2026
                  </span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <div className="promotion-tnc-btn-wrapper">
                  <a
                    href="/slots/?provider=PP"
                    className="promotion-cta-btn"
                    style={{ cursor: "pointer" }}
                  >
                    Play Now
                  </a>
                </div>
                <strong> Terms and Conditions: </strong>
                <ol>
                  <li>
                    <p>
                      80,000 prizes with a prize pool of ₱ 107,938,000 will be
                      given out from 5 May 01:00 to 19 May 2026 00:59 (GMT+8).
                    </p>
                  </li>
                  <li>
                    <p>
                      80,000 prizes with a prize pool of ₱ 107,938,000 will be
                      given out from 5 May 01:00 to 19 May 2026 00:59 (GMT+8).
                    </p>
                  </li>
                  <li>
                    <p>
                      Wheel pieces are randomly triggered on any bet with only 1
                      piece awarded at a time. Once the first wheel piece is
                      collected, you will be eligible to collect the next pieces
                      until all four are obtained.
                    </p>
                  </li>
                  <li>
                    <p>
                      Upon completing the wheel, you can tap to spin the wheel
                      and a full-screen vertical wheel will appear to reveal
                      your prize.
                    </p>
                  </li>
                  <li>
                    <p>Prizes are awarded as multipliers or Free Spins.</p>
                  </li>
                  <li>
                    <p>
                      Players can choose to play free spins instantly or later.
                      Free spins will be valid for 3 days from the time of
                      awarding, after which they will expire.
                    </p>
                  </li>
                  <li>
                    <p>Qualified Games: Sweet Bonanza 2500.</p>
                  </li>

                  <MasterGamesList
                    qualifiedGamesOnly="on"
                    customWrapperClass="gameListWrapper promotion-signup-game-list"
                    customQualifiedGames={[
                      {
                        provider: "pp",
                        gameName: "Sweet Bonanza 2500",
                      },
                    ]}
                    rank="off"
                    limit={2}
                    headerText={null}
                    linkTo={null}
                    headerTag="h2"
                  />

                  <li>
                    <p>
                      All winnings are credited as cash without any wagering
                      requirements.
                    </p>
                  </li>
                  <li>
                    <p>
                      You can track your progress on collecting the wheel pieces
                      in real time within the promotional interface.
                    </p>
                  </li>
                  <li>
                    <p>
                      Each player may win a maximum of 2 prizes during this
                      promotion .
                    </p>
                  </li>
                  <li>
                    <p>No minimum bet is required for this promotion.</p>
                  </li>
                  <li>
                    <p>
                      Pragmatic Play reserves the right to thoroughly review
                      players activities to identify any potential abuse to
                      ensure fair play within our Network Promotion. If any
                      abuse is found, Pragmatic Play reserves the right to
                      forfeit any amounts paid to winning players.
                    </p>
                  </li>
                  <li>
                    <p>
                      Pragmatic Play reserves the right to amend, suspend or
                      cancel the promotion at any time and without prior notice.
                    </p>
                  </li>
                </ol>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0px" }}
                  >
                    <thead>
                      <th> Number of Prizes </th>
                      <th> Prizes </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> 3 </td>
                        <td> x100,000 Multiplier </td>
                      </tr>
                      <tr>
                        <td> 7 </td>
                        <td> x3,000 Multiplier </td>
                      </tr>
                      <tr>
                        <td> 40 </td>
                        <td> x1,000 Multiplier </td>
                      </tr>
                      <tr>
                        <td> 450 </td>
                        <td> x500 Multiplier </td>
                      </tr>
                      <tr>
                        <td> 1,000 </td>
                        <td> x100 Multiplier </td>
                      </tr>
                      <tr>
                        <td> 3,500 </td>
                        <td> x50 Multiplier </td>
                      </tr>
                      <tr>
                        <td> 25,000 </td>
                        <td> 20 Free Spins </td>
                      </tr>
                      <tr>
                        <td> 50,000 </td>
                        <td> 10 Free Spins </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="promotion-tnc-cta">
                  <a
                    href="https://pp88.asia/tl/sweet-bonanza-2500-wheel-drops/"
                    className="promotion-cta-btn"
                    target="_blank"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
